import type { LoanMissingServicingDataMember } from '../types/LoansMissingServicingData.types';

export const formatMemberNames = (members: LoanMissingServicingDataMember[]): string =>
  members
    .flatMap((member) => {
      const name = `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim();

      return name ? [name] : [];
    })
    .join(', ');
